export default __webpack_public_path__ + "static/media/loding.89113087.gif";